module.exports = __webpack_public_path__ + "static/media/imo.4317fdd3.jpeg";